import { Vocabulary } from "./Vocabulary";
import { urlEnum } from "./urlEnum";

export interface WebsiteModel {
  name: string;
  code: string;
  url: string;
  disabled?: boolean;
}

export const WEBSITE_INTEGRATIONS: WebsiteModel[] = [
  {
    name: Vocabulary.autovit,
    code: "autovit",
    url: urlEnum.autovit,
  },
  {
    name: Vocabulary.bestauto,
    code: "bestauto",
    url: urlEnum.bestauto,
  },
  {
    name: Vocabulary.plusAuto,
    code: "plusauto",
    url: urlEnum.plusAuto,
  },
  {
    name: Vocabulary.xauto,
    code: "xauto",
    url: urlEnum.xauto,
  },
  // {
  //   name: Vocabulary.autovit + ` (${Vocabulary.secondaryAccount})`,
  //   code: "autovit_secondary",
  //   url: urlEnum.autovit + "?account=autovit_secondary",
  // },
];

/**
 * Get the ad link for a vehicle on a specific website.
 * Parses `{websiteCode}_advert_data` (JSON string or object) and returns `advert_url`.
 * @param vehicle - Vehicle object
 * @param websiteCode - Website code (e.g. "xauto", "autovit")
 * @returns The ad URL string, or null if not available
 */
export const getVehicleAdLink = (
  vehicle: any,
  websiteCode = "xauto",
): string | null => {
  if (!vehicle) return null;

  const advertField = `${websiteCode.toLowerCase()}_advert_data`;
  let advertData = vehicle[advertField];
  if (!advertData) return null;

  if (typeof advertData == "string") {
    try {
      advertData = JSON.parse(advertData);
    } catch {
      return null;
    }
  }

  if (advertData?.deactivated_at) return null;

  return advertData?.advert_url ?? null;
};

/**
 * Check if a vehicle is synced on a specific website
 * @param vehicle - Vehicle object
 * @param websiteCode - Website code (prefix)
 * @returns true if synced, false otherwise
 */
export const isVehicleSyncedOnWebsite = (
  vehicle: any,
  websiteCode: string,
): boolean => {
  if (!vehicle) return false;

  // For autodelrulate, check if slug exists
  if (websiteCode === "autodelrulate") {
    return vehicle?.slug ? true : false;
  }

  // For other websites, check if advert_data field exists
  const advertField = `${websiteCode.toLowerCase()}_advert_data`;
  return vehicle?.[advertField] ? true : false;
};
